import { Action } from 'typescript-fsa';
import * as actions from './actions';
import { Dispatch } from 'redux';
import { Storage } from 'aws-amplify';
import { loadingOperations } from '../loading';
import { getLogger } from '../../../utils';
import { systemStateMessageOperations } from '..';
import { KansatsuKirokuObsrec } from '../../../models/KansatsuKirokuObsrec';
// API
import { fetchKansatsuKirokuObsrec, getKansatsuKirokuObsrec, getArchiveStatusObsrec, uploadImage, postKansatsuKirokuObsrec } from '../../../apis';
import { getLatestKansatsuKirokuObsrec } from '../../../apis'; // 直近レコードの値を取得する処理

// amplifyの機能を活用し、認証情報を付与したURLでS3のファイルURLを取得する処理
// const getSignedUrl = async (params: { bucket: string; key: string; }) => {
//   return Storage.vault.get(params.key,
//     {
//       bucket: params.bucket,
//       level: 'public',
//       customPrefix: {
//         public: ''
//       }
//     });

// };

// 該当工事番号の記録一覧の取得
const fetch = ({ koujiBangou }: { koujiBangou: string }) => async (dispatch: Dispatch<Action<any>>) => {

  loadingOperations.startLoading()(dispatch);
  try {
    const result = await fetchKansatsuKirokuObsrec({ koujiBangou });  // 工事番号をキーとしてレコードをすべて取得する
    // // 人判断の観察記録ダウンロード機能は未実装
    // ArchiveStatusを取得するAPIをループで呼び出す
    const archiveStatus = async (record: KansatsuKirokuObsrec): Promise<null> => { // 工事のすべてのレコードのアーカイブのステータスを取得する
      const archiveStatusResult = await getArchiveStatusObsrec({ koujiBangou: record.koujiBangou, key: record.key });
      // 検索結果を観察記録のレコードに設定する
      record.downloadFileStatus = archiveStatusResult.status;
      record.downloadFileBucket = archiveStatusResult.bucket;
      record.downloadFileKey = archiveStatusResult.fileKey;
      record.downloadFileCreationDatetime = archiveStatusResult.createdAt;
      return null;
    };
    await Promise.all(result.Items.map(r => archiveStatus(r)));

    dispatch(actions.fetchRecords.done({ params: { koujiBangou }, result }));
  } catch (error) {
    dispatch(actions.fetchRecords.failed({ params: { koujiBangou }, error: error.toString() }));
    getLogger().error('kansatsuKirokuObsrec/fetch()', error);
    systemStateMessageOperations.putError({ message: '通信エラーが発生しました。' })(dispatch);
  } finally {
    loadingOperations.stopLoading()(dispatch);
  }

}

// 該当工事番号の記録キーから1レコードを取得
const get = ({ koujiBangou, key }: { koujiBangou: string; key: string }) => async (dispatch: Dispatch<Action<any>>) => {

  loadingOperations.startLoading()(dispatch);
  try {
    const result = await getKansatsuKirokuObsrec({ koujiBangou, key });
    // const result = { croppedImageBucket : "",
    //                  croppedImageKey : "",
    //                  croppedImageSignedUrl : "",
    //                  inferenceResultObsrec : "",
    //                 }; // temp
    // 画像の情報があればSignedURLを生成して返す
    if (result.croppedImageBucket && result.croppedImageKey) {
      result.croppedImageSignedUrl =
        await Storage.get(
          result.croppedImageKey,
          {
            customPrefix: {
              public: ''
            }
          }) as string
    }
    // 推論結果に含まれる画像のPresigedURLを取得して設定する
    // if (result.inferenceResultObsrec) {
    //   await Promise.all(result.inferenceResultObsrec.map(
    //     async (item) => {
    //       const url = await getSignedUrl({ key: item.overlay_img_key, bucket: item.overlay_img_bucket });
    //       item.overlay_img_presigned_url = url as string;
    //     }
    //   ));
    // }
    dispatch(actions.getRecord.done({ params: { koujiBangou, key }, result: { Item: result } }));
  } catch (error) {
    dispatch(actions.getRecord.failed({ params: { koujiBangou, key }, error: error.toString() }));
    getLogger().error('kansatsuKirokuObsrec/get()', error);
    systemStateMessageOperations.putError({ message: '通信エラーが発生しました。' })(dispatch);
  } finally {
    loadingOperations.stopLoading()(dispatch);
  }

}


// 該当工事番号のレコードから最直近で作成されたレコードを1件取得
const getLatestRecord = ({ koujiBangou }: { koujiBangou: string }) => async (dispatch: Dispatch<Action<any>>) => {

  loadingOperations.startLoading()(dispatch);
  try {
    const result = await getLatestKansatsuKirokuObsrec({ koujiBangou });
    dispatch(actions.getLatestRecord.done({ params: { koujiBangou }, result: { Item: result } }));
  } catch (error) {
    dispatch(actions.getLatestRecord.failed({ params: { koujiBangou }, error: error.toString() }));
    getLogger().error('kansatsuKirokuObsrec/getLatestRecord()', error);
    systemStateMessageOperations.putError({ message: '通信エラーが発生しました。' })(dispatch);
  } finally {
    loadingOperations.stopLoading()(dispatch);
  }

}

// 該当工事番号の記録キーから1レコードを登録
const post = (
  record: KansatsuKirokuObsrec,
  originalImageStr: string | undefined = undefined,
  originalImageContentType: string | undefined = undefined
) => async (dispatch: Dispatch<Action<any>>) => {

  loadingOperations.startLoading()(dispatch);
  try {
    // オリジナル画像が指定されているときはアップロードする
    if (originalImageStr && originalImageContentType) {
      // 拡張子をcontentTypeから取得する
      const ext = originalImageContentType.toLowerCase().endsWith('png')
        ? 'png'
        : 'jpeg'
      // ファイル名生成
      const key = `${record.inferenceId}.${ext}`;
      console.time('upload original image');
      await uploadImage({ key, imageStr: originalImageStr, contentType: originalImageContentType });
      console.timeEnd('upload original image');
      record.originalImageBucket = process.env.REACT_APP_IMAGEUPLOADBUCKETNAME || '';
      record.originalImageKey = key;
    }
    await postKansatsuKirokuObsrec({ item: record });
    dispatch(actions.postRecord.done({ params: { item: record }, result: { item: record } }));
    // 削除日時が指定されているかどうかで結果メッセージを変更
    const message = record.deletedAt ? '削除しました。' : '保存しました。';
    systemStateMessageOperations.putSuccess({ message })(dispatch);
  } catch (error) {
    dispatch(actions.postRecord.failed({ params: { item: record }, error: error.toString() }));
    getLogger().error('kansatsuKirokuObsrec/post()', error);
    systemStateMessageOperations.putError({ message: '通信エラーが発生しました。' })(dispatch);
  } finally {
    loadingOperations.stopLoading()(dispatch);
  }

}

const resetRecord = () => async (dispatch: Dispatch<Action<any>>) => {

  dispatch(actions.resetRecord());

};

export {

  fetch,
  get,
  post,
  resetRecord,
  getLatestRecord
};



// WEBPACK FOOTER //
// ./src/redux/modules/kansatsuKirokuObsrec/operations.ts